define('commons/list-columns-customizer',['jquery', 'commons/draggable-elements', 'commons/message-manager'],function($, DraggableElements, messages) {
    /**
     * 
     * Create a list columns customizer. The user will be able to add/remove any of the list's columns. The displayed columns will be saved
     * with a cookie.
     * 
     */
    var ListColumnsCustomizer = function(container, beanName, onFieldsSelected) {

        this.onFieldsSelected = onFieldsSelected;
        this.$configureBtn = null;
        this.beanName = beanName;
        this.selectedFields = [];

        this.CONSTANTS = (function() {
            var privateConstants = {
                'MAX_DISPLAYED_FIELDS': 8,
                'USER_PREFS_LIST_URL': '/userPrefs/json/fields/list',
                'USER_PREFS_CURRENTLY_DISPLAYED_LIST_URL': '/userPrefs/json/fields/displayed/list',
                'OVER_LEFT_CLASS': 'over-left',
                'OVER_RIGHT_CLASS': 'over-right'
            };

            return {
                get: function(name) {
                    return privateConstants[name];
                }
            };
        })();

        // Retrieve currently selected fields and init 'this.selectedFields'
        this._initSelectedFields();
        
        this.customizeContainer(container);
    };

    /**
     * Sets the $container element, add the 'customize' (with its behavior) button and the DnD feature.
     */
    ListColumnsCustomizer.prototype.customizeContainer = function(container) {
        this.$container = $(container);
        
        // Row click listener
        this._initBindings();

        // Drag n drop feature
        this._enableDnD(container);
    };
    
    /**
     * Adds the main click listener on the $container (table here). Handles all the 'show/hide' behavior too.
     */
    ListColumnsCustomizer.prototype._initBindings = function() {
        var here = this;
        this.$configureBtn = $("<div id='configure-columns-wrapper'><span title='Select the columns to show/hide' class='configure-columns-btn icon-cog'></span></div>");
        // Adds the configure button next to the table headers
        this.$container.before(this.$configureBtn);

        // Config btn clicked : Retrieve current state for the user, and the open the selection side-popup
        this.$configureBtn
                .click(function configureBtnClicked() {
                    // Retrieve all displayable fields
                    $
                            .ajax({
                                type: 'GET',
                                url: here.CONSTANTS.get('USER_PREFS_LIST_URL'),
                                data: 'beanName=' + here.beanName,
                                success: function onFieldsListSuccess(data) {
                                    var $body = $('body');
                                    var $content = $("<div class='field-selection-box'><div id='field-selection-box-title'>Field selection</div><div id='field-selection-form'></div></div>");
                                    var $overlay = $("<div class='overlay'></div>");
                                    var $form = $content.find('#field-selection-form');
                                    var close = function() {
                                        here._closeItem($content);
                                        here._closeItem($overlay);
                                        $body.removeClass('noscroll');
                                    };

                                    // Add a button per field with its checked state depending on whether or not the field is currently
                                    // displayed
                                    $(data).each(function(i, value) {
                                        var mandatory = value.alwaysShown ? ' disabled ' : '';
                                        var mandatoryTootlip = mandatory ? " title='Mandatory fields cannot be disabled' "
                                                : '';
                                        var selected = value.isDisplayed || value.alwaysShown ? ' checked ' : '';
                                        var displayVal = value.displayValue || value.key;
                                        $form.append("<input id='" + value.key + "' type='checkbox' class='switch-checkbox switch-checkbox-flipping-type field-selection-checkbox' " +
                                                        mandatory + selected + "></input> <label " + mandatoryTootlip +
                                                        "for='" + value.key + "' data-on='" + displayVal + "' data-off='" +
                                                        displayVal + "' title='" + displayVal + "'></label>");
                                    });
                                    $content.append("<button id='submit-field-selection-btn' class='flat-button'>Apply</button>");
                                    $content.find('button').on('click', function(event) {
                                        var $checkedFields = $form.find("input[type='checkbox']:checked");
                                        var checkedNb = $checkedFields.length;
                                        var maxFieldNb = here.CONSTANTS.get('MAX_DISPLAYED_FIELDS');

                                        if (checkedNb > maxFieldNb) {
                                            messages.warn('Only ' + maxFieldNb +
                                                    ' selected fields are allowed, please unselect ' + (checkedNb - maxFieldNb) +
                                                    ' fields');
                                        } else {
                                            var checkedFields = [];
                                            $checkedFields.each(function(i, value) {
                                                checkedFields.push(value.id);
                                            });
                                            here.selectedFields = here._mergeOldAndNewFields(here.selectedFields, checkedFields);
                                            here.onFieldsSelected(here.selectedFields);
                                            close();
                                        }
                                    });

                                    $body.append($content);
                                    $body.prepend($overlay);

                                    setTimeout(function() {
                                        $content.addClass('opened');
                                        $overlay.addClass('opened');
                                        $body.addClass('noscroll');
                                    }, 200);

                                    // Close popup when clicking anywhere on the overlay, or pressing ESC
                                    $overlay.one('click', function(e) {
                                        close();
                                    });
                                    $(document).one('keyup', function(e) {
                                        if (e.keyCode == 27) {
                                            close();
                                        }
                                    });
                                }
                            });
                });
    };

    ListColumnsCustomizer.prototype._mergeOldAndNewFields = function(oldValues, newValues){
        var result = [];
        
        for(var i = 0, length = oldValues.length; i < length ; i++){
            var current = oldValues[i];
            var currentIndexInNewFields = newValues.indexOf( current );
            // the current field still exists, save it
            if( currentIndexInNewFields !== -1 ){
                // keep this value
                result.push( current );
                // remove it from the new values
                newValues.splice(currentIndexInNewFields, 1);
            }
        }
        // add the new values
        Array.prototype.push.apply(result, newValues);
        
        return result;
    }
    
    /**
     * Closes the container (removes the 'open' class and remove nodes after transition).
     */
    ListColumnsCustomizer.prototype._closeItem = function(container) {
        // Remove nodes after transition
        this._removeAfterTransition(container);

        // Remove OPEN classes
        container.removeClass('opened');
    };

    ListColumnsCustomizer.prototype._removeAfterTransition = function(container) {
        container.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function transitionEnd(e) {
            clearTimeout(timer);
            container.remove();
        });

        // Security timer used for...guess who... FIREFOX !!!!! ahaha IE is not guilty this time :)
        var timer = setTimeout(function() {
            container.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
            container.remove();
        }, 300);
    };

    /**
     * Enable the drag n drop feature on
     * <th>. It'll perform an ajax call to POST changes in the field keys order.
     * 
     * @param container
     *            Container(table) selector
     */
    ListColumnsCustomizer.prototype._enableDnD = function(container) {
        var here = this;
        var $headers = $(container).find('th');
        
        var draggableList = new DraggableElements($headers, $headers, {
            
            handleDragEnter : function(event){
                $headers.removeClass(here.CONSTANTS.get('OVER_LEFT_CLASS'));
                $headers.removeClass(here.CONSTANTS.get('OVER_RIGHT_CLASS'));
            },
            
            handleDragStart : function(context, $element){
                // Bad selector but it's for a good cause :(
                $('table.data tr td:nth-child(' + ($element.index()+1) + ')').addClass(context.CONSTANTS.get('DRAGGING_CLASS'));  
            },
            
            handleDragOver : function(context, $element, onLeftSide){
                $element.removeClass(here.CONSTANTS.get('OVER_LEFT_CLASS'));
                $element.removeClass(here.CONSTANTS.get('OVER_RIGHT_CLASS'));
                $element.addClass(onLeftSide ? here.CONSTANTS.get('OVER_LEFT_CLASS') : here.CONSTANTS.get('OVER_RIGHT_CLASS'));
            },
            
            handleDragLeave : function(context, $element){
                $element.removeClass(here.CONSTANTS.get('OVER_LEFT_CLASS'));
                $element.removeClass(here.CONSTANTS.get('OVER_RIGHT_CLASS'));
            },
            
            handleDragEnd : function(context){
                $headers.removeClass(here.CONSTANTS.get('OVER_LEFT_CLASS'));
                $headers.removeClass(here.CONSTANTS.get('OVER_RIGHT_CLASS'));

                $('th,td').removeClass(context.CONSTANTS.get('DRAGGING_CLASS'));  
            },
            
            // The data we want to be transfered by DnD
            getDataTransferObject: function($element, isDropEvent) {
                if(isDropEvent){
                    return $element.closest('th').data('key');
                }
                return $element.data('key');
            },

            // Start/End data, same type returned by getDataTransferObject above
            dataDropped: function(sourceData, destData, onLeftSide) {
                var safeCopy = here.selectedFields.slice();
                var sourceIndex = here.selectedFields.indexOf(sourceData);

                // Values've been found
                if (sourceIndex != -1) {
                    // Remove the DnD source
                    here.selectedFields.splice(sourceIndex, 1);
                    // Find the new index of the dest
                    var destIndex = here.selectedFields.indexOf(destData);
                    if (destIndex != -1) {
                        // Increment if we're on the right side, else the remaining array's values will be shifted
                        if (!onLeftSide) {
                            destIndex++;
                        }
                        // Insert the source
                        here.selectedFields.splice(destIndex, 0, sourceData);
                        // Trigger the callback method
                        here.onFieldsSelected(here.selectedFields);
                    } else {
                        here.selectedFields = safeCopy;
                        console.log('Destination value does not exist : ' + destData);
                    }
                } else {
                    here.selectedFields = safeCopy;
                    console.log('Source value does not exist : ' + sourceData);
                }
            }
        });
    };

    ListColumnsCustomizer.prototype._initSelectedFields = function(container) {
        var here = this;
        // Retrieve all currently displayed fields
        $.ajax({
            type: 'GET',
            url: here.CONSTANTS.get('USER_PREFS_CURRENTLY_DISPLAYED_LIST_URL'),
            data: 'beanName=' + here.beanName,
            success: function onFieldsListSuccess(data) {
                here.selectedFields = data;
            }
        });
    };
    return ListColumnsCustomizer;
});

